import {inject} from 'aurelia-framework';
import { Api } from './api';
import { Router } from 'aurelia-router';

export const AppEnv 		= { Production:"Production", Dev:"Dev" };
export const app_env		= AppEnv.Production;
export const CookieDomain 	= (app_env === AppEnv.Production) ? ";domain=samantia.com;path=/;SameSite=None;Secure" : ";domain=localhost;path=/;SameSite=None;Secure";


export class AuthRequest {
	constructor(url, method){
		this.url 		= url;
		this.method 	= method;
		//this.domain		= "http://localhost:8081";
		this.domain		= (app_env === AppEnv.Production) ? "https://auth.samantia.com" : "http://localhost:6100";
		this.headers 	= {
			 'Content-Type': 'application/json',
			'Access-Control-Allow-Origin': '*'
		}
	}
}

export class Request {
	constructor(url, method){
		this.url 		= url;
		this.method 	= method;
		//this.domain		= "http://localhost:8083";
		this.domain		= (app_env === AppEnv.Production) ? "" : "http://localhost:8083";
		this.headers 	= {
			'Content-Type'					: 'application/json',
			'Access-Control-Allow-Origin'	: '*',
			//'Content-Length'				: '5242880'
			'Content-Length'				: '25242880'
		}
	}
}

export class RequestUpload {
	constructor(url, method){
		this.url 		= url;
		this.method 	= method;
		this.body		= "";
		//this.domain		= "http://localhost:8083";
		this.domain		= (app_env === AppEnv.Production) ? "" : "http://localhost:8083";
		this.headers 	= {
			 'Content-Type': 'file.type',
			'Access-Control-Allow-Origin': '*',
		}
	}
	
}

export const AuthStatus = {
	"Ok"				:"Ok",
	"Unauthenticated"	:"Unauthenticated",
}

@inject(Api, Router)
export class DataService {
	/** Component methods **/
	constructor(api, router){
		this.router		 = router;
		this.api		 = api;
		this.auth_status = AuthStatus.Unauthenticated;
		this.user		 = null;
		this.token		 = null;
		// Common space
		this.app_data	 = { "machine":"", "bufferMachine":"" };
		// Init functions
		this.auth_token();
		this.user_info	= null;
	}

	/** Public methods **/
	// Get user if auth
	// Get session token
	auth_token(){
		// Verify if auth token exists!
		//let token = this.getCookieByName("l5session");
		//let token = this.getCookieByName("smt-6825067a94590c427262c566");
		let token = this.getCookieByName("S6session");
		let request = new AuthRequest("/api/v2/sessions/id/", "GET");
		request.headers["Authorization"] = "Bearer" + token; // Bearer + token
		// Perform request
		this.api.get(request).then(response => {
			if(response.status === 201){
				// redirect
				// console.log("response: ", response);
				this.user 		 = response.data;
				this.auth_status = AuthStatus.Ok;
				this.token		 = token;

				// Get machines
				this.getUserMachines()
					.then(response => {
						return this.handleResponseUserMachines(response);
					})
			}
			else{
				// Redirect to auth service
				this.user		 = {};
				this.auth_status = AuthStatus.Unauthenticated;
				//console.log("auth raw response: ", response);
				//window.location.href = "http://localhost:8080";
				//window.location.href = "http://localhost:8080/srv/6825067a94590c427262c566/login";
				window.location.href = "https://auth.samantia.com"
			}
			
		})
		.catch( (e) => { console.log("err: ", e);});
	}

	// Get Authorization token for operations
	oper_token(){}	

	/** Private methods **/
	// Get cookies 
	getCookieByName(name){
		const match = document.cookie
			  .match(new RegExp("(^| )" + name + "=([^;]+)"));

		if (match) return match[2];
		return null;
	}// end cookie

	// Ge User info(profile) maybe
	getUserInfo(){
		let token 		= this.token
		if(!token){ return null; }

		let uid			= this.user.uid;
		let authRequest = new AuthRequest("/api/v2/users/uid?", "GET");
		let query		= new URLSearchParams({ uid: uid});
		
		authRequest.url = authRequest.url + query;
		authRequest.headers["Authorization"] = "Bearer" + token;
		return this.api.get(authRequest);
	}

	getUserMachines(){
		let uid		= this.user.uid;
		let token	= this.token;
		let request = new Request("/api/v2/users/"+uid+"/machines/", "GET");
		request.headers["Authorization"] = "Bearer=" + token;
		return this.api.get(request);
	
	}

	handleResponseUserMachines(response){
		return new Promise(resolve => {
			let status 	= response.status;
			if(status === 200){
				let machines = response.data.reverse();
				// To service
				this.app_data.machines = machines;
				resolve(200);
			}
		});
	}

	

	logout(){
		//console.log("logout =>" );
		// auth-domain => smt-6825067a94590c427262c566
		// auth-srv/
		//let token = this.getCookieByName("l5session");
		//let token = this.getCookieByName("smt-6825067a94590c427262c566");
		let token = this.getCookieByName("S6session");
		// Create request
		let request = new AuthRequest("/api/v2/sessions/id/", "DELETE");
		request.headers["Authorization"] = "Bearer " + token; // Bearer + token
		
		this.api.remove(request).then(response => {
			let status	= response.status;
			if(status === 200){
				// Remove cookie element
				//document.cookie = "l5session= ;domain=localhost;path=/;SameSite=None;Secure";
				//document.cookie = "smt-6825067a94590c427262c566= ;domain=localhost;path=/;SameSite=None;Secure";
				// => document.cookie = "S6session= ;domain=localhost;path=/;SameSite=None;Secure";
				document.cookie = "S6session= " + CookieDomain;
				// Change status app
				this.auth_status = AuthStatus.Unauthenticated;
				this.user		= null;
				// Redirect
				window.location.replace("https://auth.samantia.com");
			}
		})
	}	
}
